import type { FeedbackMessages } from './en';

const ru: FeedbackMessages = {
  qualified: {
    title: 'Благодарим Вас за участие в этом опросе!',
    body1: 'Вы можете закрыть окно браузера.',
    body2: 'Надеемся увидеть Вас снова в ближайшее время.',
    refCode: 'Референтный код: {code}',
  },
  quotaFull: {
    title: 'Этот опрос закрыт',
    body1: 'Благодарим Вас за интерес к нашему опросу.',
    body2: 'К сожалению, мы уже получили все необходимые ответы.',
    body3: 'Надеемся увидеть Вас в одном из наших будущих опросов!',
    refCode: 'Референтный код: {code}',
  },
  terminated: {
    title: 'Благодарим Вас за то, что поделились своим мнением!',
    body1:
      'Надеемся увидеть Вас в наших будущих опросах. А до тех пор желаем Вам отличного дня.',
    body2: 'Пожалуйста, закройте это окно браузера.',
    refCode: 'Референтный код: {code}',
  },
  mismatch: {
    title: 'Благодарим Вас за интерес',
    body1: 'К сожалению, Вы не входите в целевую группу для данного конкретного опроса.',
    body2: 'Вы можете закрыть эту страницу.',
    code: 'Код: {code}',
  },
  error: {
    title: 'Мы не можем обработать Ваш запрос',
    linkProblemDetailed:
      'Ссылка, по которой Вы перешли, работает некорректно. Пожалуйста, убедитесь, что ссылка в адресной строке совпадает с той, что была Вам предоставлена, и попробуйте снова.',
    linkProblemGeneric:
      'Ссылка, по которой Вы перешли, работает некорректно. Пожалуйста, попробуйте снова.',
    contactPerson:
      'Если проблема не исчезнет, пожалуйста, сообщите об этом человеку, от которого Вы получили ссылку.',
    errorCode: 'Код ошибки: {code}',
  },
};

export default ru;
